export enum RoomBookingStatusEnum {
    Selected = "selected",
    InvalidAsTooManyGuests = "invalid",
    Unavailable = "unavailable",
    Unselected = "unselected",
    InvalidAsNoGuest = "invalidAsNoGuest",
    InvalidAsNoEnoughGuestForApt = "invalidAsNoEnoughGuestForApt",
}

export class RoomBooking {
    status: RoomBookingStatusEnum;
    aptMinPax: number;
    maxPax: number;
    singleRoomSupplementFactor: number;
    thirdGuestOnwardDiscountFactor: number;
    babyPrice: number;
    childDiscount: number;
    extraPriceForThisRoom: number;
    aptDiscountPerPerson: number;

    adultsNumber: number;
    childrenNumber: number;
    babiesNumber: number;


    calculatedPrice: number;
}